import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    extendedAllowedAttachmentExtensions: ['rtf', 'zip', '7z', 'rar', 'csv', 'opm'],
};
